import { ITableField } from 'shared/Table'
import { IGrade } from 'screens/Protection/protection.types'

const gradeTableFields: ITableField<IGrade, keyof IGrade | string>[] = [
  {
    key: 'team',
    getter: (item: IGrade) => item.team?.name || '--',
    sortGetter: (item: IGrade) => item.team?.name || '',
    header: 'Команда',
    width: '178px',
  },
  {
    key: 'defenceTitle',
    getter: (item: IGrade) => item.defence?.title,
    sortGetter: (item: IGrade) => item.defence?.title,
    header: 'Название защиты',
    width: '178px',
  },
  {
    key: 'experts',
    getter: (item: IGrade) => {
      if (!item.experts || item.experts.length === 0) return '--'
      return item.experts
        .map((expert) => expert.name)
        .filter(Boolean)
        .join(', ')
    },
    sortGetter: (item: IGrade) => {
      if (!item.experts || item.experts.length === 0) return ''
      return item.experts
        .map((expert) => expert.name)
        .filter(Boolean)
        .join(', ')
    },
    header: 'Эксперт',
    width: '178px',
  },
  {
    key: 'score',
    getter: (item: IGrade) =>
      item.totalScore !== undefined && item.totalScore !== null ? item.totalScore.toString() : '--',
    sortGetter: (item: IGrade) => item.totalScore ?? 0,
    header: 'Оценка',
    width: '178px',
  },
]

export default gradeTableFields
